import { z } from "zod";
import { ShortText, MediumText, StakeholderQuadrant, idString, } from "./common.js";
const Stakeholder = z
    .object({
    id: idString,
    name: ShortText,
    /** The tenant member `name` names, when picked from the people picker. */
    userId: z.string().uuid().nullable().optional(),
    role: ShortText.optional(),
    quadrant: StakeholderQuadrant,
    note: MediumText.optional(),
})
    .strict();
/**
 * Stakeholder Map — Verify, multi (addable). Power × Interest 2×2 keyed
 * by a single `quadrant` enum (satisfy / manage / monitor / inform).
 */
export const StakeholderMapParamsSchema = z
    .object({
    stakeholders: z.array(Stakeholder).max(100),
})
    .strict();
export const defaultStakeholderMapParams = {
    stakeholders: [],
};
//# sourceMappingURL=stakeholderMap.js.map